(function (app, ng) {
    app.controller("covidFaqsCtrl", covidFaqsCtrl);
    covidFaqsCtrl.$inject = ["covid19Constant", "$mdDialog"];

    function covidFaqsCtrl(covid19Constant, $mdDialog) {
        var $ctrl = this;

        $ctrl.faqs = covid19Constant.faqs;

        $ctrl.closeDialog = function ($event) {
            return $mdDialog.hide($event);
        };

        $ctrl.$onInit = function () {
        };
    }
})(window.app, window.angular); // jshint ignore:line